import React from "react";
import "./SeparationLine.css"; // Import the CSS file for styling

const SeparationLine = () => {
  return <hr className="separation-line" />;
};

export default SeparationLine;
